import { FormField } from '@ipfabric/ui-components/FormField/FormField';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { tacacsDelay, tacacsRetry } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type AuthorizationFailureFieldValues = {
  commandAuthorizationFailureRetry: string;
  commandAuthorizationFailureDelay: string;
};

export type AuthorizationFailureOutputValues = {
  commandAuthorizationFailureRetry: number;
  commandAuthorizationFailureDelay: number;
};

export const authorizationFailure: FormSnippet<
  DiscoverySettingsObject,
  AuthorizationFailureFieldValues,
  AuthorizationFailureOutputValues
> = {
  render: ({ form }) => (
    <FormField
      className='@container'
      description='Number of retries to run a command after an authorization failure and delay between each attempt.'
      label='Command Authorization failure'
    >
      <div className='flex @xl:flex-row @xl:gap-2 flex-col gap-0.5'>
        <FormTextField
          control={form.control}
          type='number'
          name='commandAuthorizationFailureRetry'
          endAdornment='retries'
          inputWidthClassName='w-60'
        />
        <span className='flex-fixed leading-8'>with delay of</span>
        <FormTextField
          control={form.control}
          type='number'
          name='commandAuthorizationFailureDelay'
          endAdornment='milliseconds'
          inputWidthClassName='w-60'
        />
      </div>
    </FormField>
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.commandAuthorizationFailureRetry =
      model.cliRetryLimit?.tacacs?.retry?.toString() ?? '';
    fieldValuesDraft.commandAuthorizationFailureDelay =
      model.cliRetryLimit?.tacacs?.delay?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.cliRetryLimit ??= {};
    modelDraft.cliRetryLimit.tacacs ??= {};
    modelDraft.cliRetryLimit.tacacs.retry =
      transformedValues.commandAuthorizationFailureRetry;
    modelDraft.cliRetryLimit.tacacs.delay =
      transformedValues.commandAuthorizationFailureDelay;
  },
  schema: z.object({
    commandAuthorizationFailureRetry: hookFormZod.numberInputWith(
      hookFormZod.minMax(tacacsRetry.min, tacacsRetry.max),
    ),
    commandAuthorizationFailureDelay: hookFormZod.numberInputWith(
      hookFormZod.minMax(tacacsDelay.min, tacacsDelay.max),
    ),
  }),
};
